<template>
<div class="chapter">
<div class="inner_page">
<div>
<div class="ipadfp"><img alt="Cover: Department of Temporal Investigations: Shield of the Gods, by Christopher L. Bennett" class="imagefp" src="image/9781501164880.jpg"/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?8c4a20c8